export function isGUID(str: string): boolean {
    const regex = new RegExp(
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
    );
    return regex.test(str);
}



// WEBPACK FOOTER //
// ./src/utils/isGUID.ts